import React from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import FiltroFechasComponent from "./Componentes/FiltroFechas/FiltroFechas.component";
import HistorialComponent from "./Componentes/Historial/Historial.component";
import * as CotizacionActions from "./../../Core/Actions/Cotizacion.action";
import "./Historial.page.scss";

class HistorialPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fechaInicio: new Date(),
      fechaFin: new Date(),
      cotizaciones: [],
    };
  }

  componentDidMount() {
    let fechaIni = new Date();
    fechaIni.setMonth(fechaIni.getMonth(), -2);

    this.setState({
      fechaInicio: fechaIni,
      fechaFin: new Date(),
      cotizaciones: [],
    });
    this.buscarCotizaciones();
  }

  buscarCotizaciones = async () => {
    const { buscarCotizacionPorCliente } = this.props;
    await buscarCotizacionPorCliente();
    this.filtrarCotizaciones();
  };

  handleFiltroFechas = async (fechaIni, fechaFin) => {
    await this.setState({
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
    });

    this.filtrarCotizaciones();
  };

  filtrarCotizaciones = () => {
    const { fechaInicio, fechaFin } = this.state;
    const { Cotizaciones } = this.props.cotizacionReducer;

    const fechaInicioF = format(fechaInicio, "yyyyMMdd");
    const fechaFinF = format(fechaFin, "yyyyMMdd");

    const cotizacionesFiltradas = Cotizaciones.filter((cotizacion) => {
      const { Fecha_Creacion } = cotizacion.datos;
      const FechaCreacionF = format(Fecha_Creacion.toDate(), "yyyyMMdd");
      return FechaCreacionF >= fechaInicioF && FechaCreacionF <= fechaFinF;
    });

    this.setState({
      cotizaciones: cotizacionesFiltradas,
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-12 col-md-4">
          <FiltroFechasComponent filtroFechas={this.handleFiltroFechas} />
        </div>
        <div className="col-12 col-md-8">
          <HistorialComponent cotizaciones={this.state.cotizaciones} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ cotizacionReducer }) => {
  return { cotizacionReducer };
};

const mapDispatchToProps = {
  ...CotizacionActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistorialPage);
